import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import Konva from 'konva';
import { Image } from 'react-konva';
import { UiRegionItem } from 'utils/cfUiItems/base';
import { useMediaState } from 'modules/Canvas/contexts/MediaProvider/MediaState';
import { scaleToFit } from 'utils/canvas/calcScale';
import { useLoadMask } from 'components/Canvas/Mask/hooks';
import { setCursor } from 'components/Canvas/helpers';

export const DEFAULT_MASK_OPACITY = 0.7;

export const Mask: React.FC<Props> = ({ onMouseEnter, onMouseLeave, opacity = DEFAULT_MASK_OPACITY, region }) => {
  const color = region.regionData.color;
  const maskRef = useRef<Konva.Image>(null);
  const img = useLoadMask(region, color);
  const { imageData } = useMediaState();
  const scale = useMemo(() => {
    if (!imageData || !img) return { x: 1, y: 1 };
    return scaleToFit(imageData)(img);
  }, [imageData, img]);

  const handleMouseEnter = useCallback((evt: Konva.KonvaEventObject<MouseEvent>) => {
    onMouseEnter?.(evt);
    setCursor(evt, 'pointer');
  }, []);

  const handleMouseLeave = useCallback((evt: Konva.KonvaEventObject<MouseEvent>) => {
    onMouseLeave?.(evt);
    setCursor(evt, 'auto');
  }, []);

  useEffect(() => {
    if (maskRef.current) {
      maskRef.current.cache();
      maskRef.current.drawHitFromCache();
    }
  }, [maskRef.current]);

  return img ? (
    <>
      <Image scale={scale} ref={maskRef} image={img} opacity={opacity} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
    </>
  ) : null;
};

interface Props {
  region: UiRegionItem;
  // scale: number;  commenting because unused
  opacity?: number;
  onMouseEnter?: (evt: Konva.KonvaEventObject<MouseEvent>) => void;
  onMouseLeave?: (evt: Konva.KonvaEventObject<MouseEvent>) => void;
  onMouseMove?: (evt: Konva.KonvaEventObject<MouseEvent>) => void;
  scale?: number;
}
